import * as React from 'react';
import * as styles from '../TilesView.css';
import { IUser } from '../../../interfaces/IUser';
import { ILike } from '../../../interfaces/ILike';
import { Helper } from '../../../Helper';
import { IALikes } from '../../likes/Likes';
import { IAComments } from '../../comments/Comments';
import { IAIcon } from '../../icon/Icon';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAUniqueViews } from '../../uniqueViews/UniqueViews';
import { Environment } from '../../../services/Environment';
import { IMessageCategory, IMessageIAConfiguration, IMessageIAMessageBgImagesFromBlob } from '../../../interfaces/IMessage';
import { IEnvironment } from '../../../interfaces/IEnvironment';
import { IAMessageVideo } from '../../messages/video/MessageVideo';
import { IAMessageCategories } from '../../viewer/categories/MessageCategories';
import { IFontSlots } from '../../../interfaces/IFontSlots';
import Moment from 'react-moment';

export interface IProps {
  user?: IUser;
  author?: IUser;
  id?: string;
  tenant?: string;
  component?: string;
  instance?: string;
  token?: string;
  source?: string;
  index?: number;
  item?: any;
  layout?: number;
  environment?: IEnvironment;
  resultSourceId?: string;
  siteCollection?: string;
  listName?: string;
  title?: string;
  image?: string;
  iaMessageBgImagesFromBlob?: IMessageIAMessageBgImagesFromBlob;
  iaConfiguration?: IMessageIAConfiguration;
  teaser?: string;
  videoUrl?: string;
  categories?: IMessageCategory[];
  showSkeleton?: boolean;
  likesEnabled?: boolean;
  commentsEnabled?: boolean;
  startDate?: Date;
  backgroundColor?: string;
  overlayColor?: string;
  borderColor?: string;
  borderRadius?: number;
  highlightColor?: string;
  itemTextColor?: string;
  width?: number;
  likes?: ILike[];
  commentCount?: number;
  height: number;
  numberOfElements?: number;
  isMobile?: boolean;
  onClickEdit?: (content: any) => void;
  onClickOpen?: () => void;
  onClickPreview?: (content: any) => void;
  onClickCopy?: (content: any) => void;
  onClickDelete?: (content: any) => void;
  likesUpdated?: (likes: ILike[]) => void;
  commentsUpdated?: (comments: number) => void;
  commentsClick?: () => void;
  showImage?: boolean;
  showTitle?: boolean;
  showCategories?: boolean;
  showTeaser?: boolean;
  showAuthor?: boolean;
  showStartDate?: boolean;
  showLikes?: boolean;
  showComments?: boolean;
  showCommandBarItems?: boolean;
  showUniqueViews?: boolean;
  uniqueViewsCount?: number;
  isUnread?: boolean;
  unReadHighlight?: string;
  showPinIcon?: boolean;
  showLikesDimmed?: boolean;
  showCommentsDimmed?: boolean;
  showUniqueViewsDimmed?: boolean;
  fontSlots?: IFontSlots
  userLocation?: string;
  reactionOptions?: string[];
  showEmojiPickerExpandButton?: boolean;
}

export interface IState {
  commandaBarOpen: boolean;
  isHovering: boolean;
  currentCardNumber: number;
  showVideoOverlay: boolean;
}

export class TilesContentElement extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      commandaBarOpen: false,
      isHovering: false,
      currentCardNumber: 0,
      showVideoOverlay: true,
    };
  }

  private getClassNumber(): any {
    switch (this.props.index) {
      case 1:
        return styles.IA_tilesItem_1;
      case 2:
        return styles.IA_tilesItem_2;
      case 3:
        return styles.IA_tilesItem_3;
      case 4:
        return styles.IA_tilesItem_4;
      default:
        return styles.IA_tilesItem_0;
    }
  }


  public render(): JSX.Element {
    let commandBarItems: Array<any> = [];
    if (this.props.onClickEdit != undefined && !this.props.isMobile) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `edit-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickEdit(this.props.item)}
        >
          <IAIcon
            title="Edit"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Edit}
          </div>
        </div>
      );
    }
    if (this.props.onClickOpen != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `open-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickOpen()}
        >
          <IAIcon
            title="Open"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Open}
          </div>
        </div>
      );
    }
    if (this.props.onClickPreview != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `preview-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickPreview(this.props.item)}
        >
          <IAIcon
            title="Preview"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Preview}
          </div>
        </div>
      );
    }
    if (this.props.onClickCopy != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `copy-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickCopy(this.props.item)}
        >
          <IAIcon
            title="Copy"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Copy}
          </div>
        </div>
      );
    }
    if (this.props.onClickDelete != undefined && !this.props.isMobile) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `delete-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickDelete(this.props.item)}
        >
          <IAIcon
            title="Close"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Delete}
          </div>
        </div>
      );
    }

    let minHeight = 0;
    const likesShouldBeShown = this.props.likesEnabled && this.props.showLikes;
    const commentsShouldBeShown = this.props.commentsEnabled && this.props.showComments;
    if (likesShouldBeShown && commentsShouldBeShown && this.props.showCommandBarItems) {
      minHeight = minHeight < 122 ? 122 : minHeight;
    }
    if (this.props.showLikes && this.props.showComments && !this.props.showCommandBarItems) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }
    if (this.props.showLikes && !this.props.showComments && this.props.showCommandBarItems) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }
    if (!this.props.showLikes && this.props.showComments && this.props.showCommandBarItems) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }
    if (this.props.showCommandBarItems && minHeight < 122) {
      minHeight = 122;
    }

    let thumbnailImage = this.props.image;
    if (this.props.iaMessageBgImagesFromBlob?.StandardSmall) {
      thumbnailImage = this.props.iaMessageBgImagesFromBlob?.StandardLarge;
    } else if (this.props.image != null) {
      thumbnailImage = thumbnailImage.replace(/StandardLarge|StandardSmall|Square|Wide|Full|DefaultRendition/, "StandardLarge").replace("version=&", `version=${this.props.item.modified ? (new Date(this.props.item.modified)).toISOString().replace(/[^\d]/g, '') : ""}&ignoreCache=false&`);
      thumbnailImage = Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, thumbnailImage, this.props.item.modified ? (new Date(this.props.item.modified)).toISOString().replace(/[^\d]/g, '') : undefined, "StandardLarge", this.props.iaConfiguration?.cropSettings, false);
    }

    let commandBarWidth = (!this.props.showSkeleton && this.props.showLikes || !this.props.showSkeleton && this.props.showComments || !this.props.showSkeleton && this.props.showCommandBarItems) ? 40 : 0;
    let backgroundColor = (!this.props.showSkeleton && this.props.backgroundColor);
    let textColor = this.props.itemTextColor;

    let displayoverlayColor = !this.props.showSkeleton ? `linear-gradient(transparent, ${this.props.overlayColor})` : "linear-gradient(transparent, #000000FF)";

    let displayBorderColor = `1px solid ${this.props.borderColor}`;
    if (this.props.borderColor != null) {
      displayBorderColor = displayBorderColor.replace(`none`, `1px solid ${this.props.borderColor}`);
    }
    let tilesMedia = [];
    tilesMedia.push(
      <div
        key={`mediaElement_${this.props.id}`}
        className={this.props.videoUrl != undefined && this.props.image == undefined ? styles.IA_videoElement : styles.IA_imageElement}
        style={{
          backgroundImage: this.props.showImage ? `url(${thumbnailImage})` : `url(none)`,
          backgroundColor: this.props.backgroundColor != undefined ? this.props.backgroundColor : "transparent"
        }}
        onClick={() => this.props.onClickOpen()}
      >
        {this.props.videoUrl != undefined && this.props.image == undefined &&
          <div
            style={{
              position: "relative",
              height: "100%",
              width: "100%",
              boxSizing: "border-box"
            }}

            onMouseOver={() => {
              this.setState({ isHovering: true, showVideoOverlay: false });
            }}
            onMouseOut={() => {
              this.setState({ isHovering: false, showVideoOverlay: true });
            }}
            onClick={!this.props.videoUrl ? () => this.props.onClickOpen() : undefined}
          >
            <IAMessageVideo
              environment={this.props.environment}
              tenant={this.props.tenant}
              token={this.props.token}
              height="100%"
              width="100%"
              videoUrl={this.props.videoUrl}
            />
          </div>
        }
        {this.state.showVideoOverlay &&
          <div
            style={{
              backgroundImage: displayoverlayColor,
              width: "100%",
              height: "70%",
              position: "absolute",
              bottom: 0
            }}
          />
        }
        {this.state.showVideoOverlay &&
          <div
            style={{
              backgroundImage: displayoverlayColor,
              width: "100%",
              height: "50%",
              position: "absolute",
              bottom: 0,
              opacity: 0.3
            }}
          />
        }
        <div
          style={{
            backgroundColor: "transparent",
            width: "100%",
            height: "50%",
            position: "absolute",
            top: 0,
          }}
          onMouseOver={() => {
            this.setState({ isHovering: true, showVideoOverlay: false });
          }}
          onMouseOut={() => {
            this.setState({ isHovering: false, showVideoOverlay: true });
          }}
        />
      </div>
    );

    return (
      <div
        role="listitem"
        tabIndex={this.props.layout}
        className={this.getClassNumber()}
        style={{
          boxSizing: "border-box",
          backgroundColor: backgroundColor,
          border: displayBorderColor,
          borderRadius: this.props.borderRadius
          // borderLeft: this.props.isUnread? `6px solid ${this.props.unReadHighlight? this.props.unReadHighlight: '#ffb900'}`: ''
        }}
      >
        {this.props.showPinIcon &&
          <div
            className={styles.IA_pinCoverOverlay}
            style={{
              cursor: this.props.onClickOpen ? "pointer" : undefined
            }}
            onClick={this.props.onClickOpen ? () => this.props.onClickOpen() : undefined}
          >
            <img
              src="https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/pinned.png"
              style={{
                width: 22,
                height: 22
              }}
            />
          </div>
        }
        {this.props.isUnread && <div style={{ height: "100%", zIndex: 1, position: "absolute", borderLeft: `6px solid ${this.props.unReadHighlight ? this.props.unReadHighlight : "#ffb900"}` }}> </div>}
        {!this.props.showSkeleton && tilesMedia}
        {!this.props.showSkeleton &&
          <div className={styles.IA_content}
            style={{
              visibility: this.state.showVideoOverlay ? "visible" : "hidden",
              width: '100%',
              paddingTop: "2.0em",
              height: "auto"
            }}
          >
            <div
              style={{
                width: `calc(100% - ${commandBarWidth}px)`,
                alignItems: "flex-end",
                bottom: "10px",
                position: "absolute",
                height: "fit-content"
              }}
            >
              {this.props.showCategories && this.props.categories != undefined && this.props.categories.length > 0 &&
                <IAMessageCategories
                  categories={this.props.categories}
                  paddingLeft={10}
                  paddingRight={10}
                  paddingBottom={this.props.index === 0 ? 0 : 5}
                  showOverflowCounter
                  fontSlots={this.props.fontSlots}
                  disablePopup={this.props.isMobile}
                  textColorWhenTransparentBackground={textColor}
                />
              }
              {this.props.showTitle &&
                <div
                  className={styles.IA_title}
                  style={this.props.numberOfElements === 2 ? {
                    color: textColor,
                    fontSize: window.innerWidth < 790 ? 16 : (window.innerWidth < 1024 ? 22 : (window.innerWidth < 1600 ? 24 : 28)),
                    lineHeight: window.innerWidth < 1024 ? "26px" : (window.innerWidth < 1600 ? "32px" : "42px"),
                    fontWeight: 400,
                    lineClamp: 1,
                    WebkitLineClamp: 1,
                    fontFamily: this.props.fontSlots?.heading?.fontFamily
                  } : {
                    color: textColor,
                    fontWeight: this.props.isUnread ? "bold" : "normal",
                    fontFamily: this.props.fontSlots?.heading?.fontFamily
                  }}
                  onClick={() => this.props.onClickOpen()}
                >
                  {this.props.title}
                </div>
              }
              {this.props.showTeaser && this.props.teaser != undefined &&
                <div
                  className={styles.IA_teaser}
                  style={{
                    color: textColor,
                    fontFamily: this.props.fontSlots?.body?.fontFamily
                  }}
                  onClick={() => this.props.onClickOpen()}
                >
                  {this.props.teaser}
                </div>
              }
              {(this.props.showAuthor || !this.props.showSkeleton && this.props.showStartDate) &&
                <div
                  className={styles.IA_authorAndDate}
                  style={{
                    color: textColor,
                    fontFamily: this.props.fontSlots?.body?.fontFamily
                  }}
                  onClick={() => this.props.onClickOpen()}
                >
                  {this.props.author != undefined && this.props.author?.displayName != undefined && this.props.showAuthor &&
                    <div className={styles.IA_author}>{`${this.props.author?.displayName} `}</div>
                  }
                  {this.props.showStartDate &&
                    <div style={{ float: "left" }}>
                      <Moment
                        format="L"
                        locale={this.props.userLocation ?? navigator.language}
                      >
                        {this.props.startDate}
                      </Moment>
                    </div>
                  }
                </div>
              }
            </div>
            {(likesShouldBeShown || !this.props.showSkeleton && commentsShouldBeShown || !this.props.showSkeleton && this.props.showUniqueViews || !this.props.showSkeleton && this.props.showCommandBarItems) &&
              <div className={styles.IA_commandBar}>
                {likesShouldBeShown && this.props.id != undefined &&
                  <IALikes
                    highlightColor={this.props.highlightColor}
                    color={this.props.itemTextColor}
                    itemId={this.props.id}
                    user={this.props.user}
                    tenant={this.props.tenant}
                    component={this.props.component}
                    instance={this.props.instance}
                    token={this.props.token}
                    environment={this.props.environment}
                    source={this.props.source}
                    likes={this.props.likes}
                    likesUpdated={(likes: ILike[]) => this.props.likesUpdated(likes)}
                    displayVertical={true}
                    showEmojiPickerExpandButton={this.props.showEmojiPickerExpandButton}
                    reactionOptions={this.props.reactionOptions}
                    showDimmed={this.props.showLikesDimmed}
                    isMobile={this.props.isMobile}
                  />
                }
                {commentsShouldBeShown && this.props.id != undefined &&
                  <div>
                    <IAComments
                      color={this.props.highlightColor}
                      itemId={this.props.id}
                      user={this.props.user}
                      tenant={this.props.tenant}
                      component={this.props.component}
                      instance={this.props.instance}
                      token={this.props.token}
                      environment={this.props.environment}
                      commentCount={this.props.commentCount}
                      commentsUpdated={(comments: number) => this.props.commentsUpdated(comments)}
                      commentsClick={() => this.props.commentsClick()}
                      displayVertical={true}
                      showDimmed={this.props.showCommentsDimmed}
                    />
                  </div>
                }
                {this.props.showUniqueViews && this.props.id != undefined &&
                  <IAUniqueViews
                    color={this.props.highlightColor}
                    itemId={this.props.id}
                    user={this.props.user}
                    tenant={this.props.tenant}
                    component={this.props.component === "Messages" ? "Message" : "Event"}
                    instance={this.props.instance}
                    token={this.props.token}
                    environment={this.props.environment}
                    source={this.props.source}
                    uniqueViews={this.props.uniqueViewsCount}
                    displayVertical={true}
                    showDimmed={this.props.showUniqueViewsDimmed}
                  />
                }
                {this.props.showCommandBarItems && this.props.showCommandBarItems &&
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ commandaBarOpen: !this.state.commandaBarOpen })
                    }}
                  >
                    <div>
                      <IAIcon
                        color="#333"
                        title="Show Action"
                        size={18}
                      /></div>
                    {this.state.commandaBarOpen &&
                      <ul
                        className={styles.IA_cardBarItems}
                      >
                        {commandBarItems}
                      </ul>}
                  </div>
                }
              </div>
            }
          </div>
        }
        {this.props.showSkeleton &&
          <div
            className={styles.IA_skeletonItems}
          >
            <div
              className={styles.IA_skeleton}
              style={{
                height: this.props.height
              }}
            />
          </div>
        }
      </div>
    );
  }


}